module.exports = __webpack_public_path__ + "static/img/96002C_4_R_20200623_LC.62ca433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96002C_4_R_20200623_LC.png
// module id = zl1+
// module chunks = 0